import { render } from "./p-box-widget.vue?vue&type=template&id=c7a2ceda"
import script from "./p-box-widget.vue?vue&type=script&lang=js"
export * from "./p-box-widget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-box-widget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7a2ceda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7a2ceda', __exports__)) {
    api.reload('c7a2ceda', __exports__)
  }
  
  module.hot.accept("./p-box-widget.vue?vue&type=template&id=c7a2ceda", () => {
    api.rerender('c7a2ceda', render)
  })

}


export default __exports__